import React, { useCallback, useState } from 'react';

import type { UserContext } from '@zola-helpers/client/dist/es/@types';

import { isCardWithSimpleSignup } from '../../paper/cards/constants/cardTypeFeatures/cardTypesWithSimpleSignup';
import { PaperOnboardTypes } from './constants';
import {
  OpenPaperOnboardProps,
  PaperOnboardContext,
  PaperOnboardContextType,
} from './PaperOnboardContext';

export const PaperOnboardProvider: React.FC<{
  initialState?: PaperOnboardContextType;
  isPushSignupIntoCustomization: boolean;
  userContext: UserContext;
}> = ({ children, isPushSignupIntoCustomization, userContext, ...initialState }) => {
  const [updatedPaperOnboardCallback, setUpdatedPaperOnboardCallback] = useState<
    (() => void) | undefined
  >();
  const [updatedPaperOnboardType, setUpdatedPaperOnboardType] =
    useState<PaperOnboardContextType['paperOnboardType']>(undefined);
  const [updatedProjectType, setUpdatedProjectType] = useState<string | undefined>();
  const [updatedRedirectHref, setUpdatedRedirectHref] = useState<string | undefined>();

  const openPaperOnboard = useCallback(
    ({
      paperOnboardCallback,
      paperOnboardType,
      projectType,
      redirectHref,
    }: OpenPaperOnboardProps) => {
      /**
       * When needing to open onboard for wedding shower and holiday cards, show simple signup
       * to allow account creation without details like partner name and wedding date
       */
      const adjustedPaperOnboardType =
        (paperOnboardType === PaperOnboardTypes.QUICK_ONBOARD ||
          paperOnboardType === PaperOnboardTypes.QUICK_SIGNUP ||
          paperOnboardType === PaperOnboardTypes.QUICK_SIGNUP_CHECKOUT ||
          paperOnboardType === PaperOnboardTypes.QUICK_SIGNUP_GUEST_LIST) &&
        isCardWithSimpleSignup(projectType)
          ? PaperOnboardTypes.SIMPLE_SIGNUP
          : paperOnboardType;

      setUpdatedPaperOnboardCallback(() => paperOnboardCallback);
      setUpdatedPaperOnboardType(adjustedPaperOnboardType);
      setUpdatedProjectType(projectType);
      setUpdatedRedirectHref(redirectHref);
    },
    []
  );

  return (
    <PaperOnboardContext.Provider
      value={{
        ...initialState,
        isPushSignupIntoCustomization,
        openPaperOnboard,
        paperOnboardCallback: updatedPaperOnboardCallback,
        paperOnboardType: updatedPaperOnboardType,
        projectType: updatedProjectType,
        redirectHref: updatedRedirectHref,
        userContext,
      }}
    >
      {children}
    </PaperOnboardContext.Provider>
  );
};
